"use strict";
// Copyright (C) 2017-2026 Smart code 203358507
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var GamepadContext = (0, react_1.createContext)(null);
exports.default = GamepadContext;
